<template>
<div id="dashboard-page">
    <b-card class="mb-5">
        <b-row>
            <b-col md="10">
                <h3>Reimbursement</h3>
                <b-breadcrumb>
                    <b-breadcrumb-item><router-link to="/dashboard/">Dashboard</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item><router-link to="/reimbursement">Reimbursement</router-link></b-breadcrumb-item>
                    <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
                </b-breadcrumb>
            </b-col>
            <b-col md="2 mt-3">
                <b-button v-b-tooltip.hover.top title="Download to Excel" @click="doExportToExcel" variant="info" class="mb-2 btn-download float-right"><font-awesome-icon icon="download"/></b-button>
            </b-col>
        </b-row>
        <div class="border-bottom mb-2"></div>
        <b-row>
            <b-col md='8' class="mb-3">
                <div class="d-flex">
                    <span class="my-3 dashboard-border active"><router-link to="/reimbursement/general" style="color:#0056b3!important;">{{$route.name}}</router-link></span>
                    <span class="ml-4 my-3 dashboard-border"><router-link to="/reimbursement/payment">Payment Reimbursement</router-link></span>
                </div>
            </b-col>
        </b-row>
        <div class="border-bottom mb-2"></div>
        <b-form v-on:submit.prevent="doFilter">
            <b-row>
                <b-col md="12">
                    <div v-if="$store.getters['account/accountData'].roleDownStream[0].role === 'ADMIN'">
                        <b-row class="mt-2 mb-2">
                            <b-col md="3 mb-2">
                                <b-form-input placeholder="Employee" v-model="tableFilter.search_employee"/>
                            </b-col>
                            <b-col md="3 mb-2">
                                <b-form-select v-model="tableFilter.parent" :options="parentList" />
                            </b-col>
                            <b-col md="3 mb-2">
                                <date-picker v-model="tableFilter.date" type="date" range placeholder="Date Range"></date-picker>
                            </b-col>
                            <b-col md="3 mb-2">
                                <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search"><font-awesome-icon icon="search"/> Filter</button>
                                <button @click="clearFilter()" class="ml-0 btn btn-outline-primary float-right" id="btn-search"><font-awesome-icon icon="times-circle"/> Clear Filter</button>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else>
                        <b-row class="mt-2 mb-2">
                            <b-col md="2 mb-2">
                                <b-form-input placeholder="Employee" v-model="tableFilter.search_employee"/>
                            </b-col>
                            <b-col md="2 mb-2">
                                <date-picker v-model="tableFilter.date" type="date" range placeholder="Date Range"></date-picker>
                            </b-col>
                            <b-col md="2 mb-2">
                                <b-form-select v-model="tableFilter.reimbursementType" :options="reimbursementList" />
                            </b-col>
                            <b-col md="2 mb-2">
                                <b-form-select v-model="tableFilter.statusreimbursement" :options="statusList" />
                            </b-col>
                            <b-col md="4 mb-2">
                                <button type="submit" class="ml-2 btn btn-primary float-right" id="btn-search"><font-awesome-icon icon="search"/> Filter</button>
                                <button @click="clearFilter()" class="ml-0 btn btn-outline-primary float-right" id="btn-search"><font-awesome-icon icon="times-circle"/> Clear Filter</button>
                            </b-col>
                            <!-- <b-col md="4">
                                <b-form-input :placeholder="'Filter No. Request'" v-model="tableFilter.no_request" v-on:afterHit="doFilter" customQueryParamName="search" />
                            </b-col> -->
                            <!-- <b-col md="4">
                                <typeahead ref="technicianTypeahead" :preventAutofocus="false" :labelFields="['firstName', 'lastName']" :placeholder="'Filter By Employee'" :urlSearch="apiUrl.profile" arr-response="profile" :model="tableFilter.userRequestedBy" v-on:afterHit="doFilter" customQueryParamName="search" />
                            </b-col> -->
                        </b-row>
                    </div>
                    <div v-if="$store.getters['account/accountData'].roleDownStream[0].role === 'ADMIN'">
                        <b-row class="mt-2 mb-2">
                            <b-col md="3 mb-2">
                                <b-form-select v-model="tableFilter.reimbursementType" :options="reimbursementList" />
                            </b-col>
                            <b-col md="3 mb-2">
                                <b-form-select v-model="tableFilter.statusreimbursement" :options="statusList" />
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-form>
        <paginated-table ref="dataTable" :can-delete="false" :can-edit="false" :can-approve="false" :can-reject="false" :data-url="apiUrl.reimbursement" :data-key="dataKey" :data-columns="columns" :data-params="['search_employee', 'requestedBy', 'reimbursement_type_uuid', 'parent_uuid', 'no_request', 'start_date', 'end_date', 'requested_by', 'approved_by', 'rejected_by', 'status']">
        </paginated-table>
    </b-card>
</div>
</template>
<script>
    import PaginatedTable from '@/components/PaginatedTable'
    import DatePicker from 'vue2-datepicker'
    import 'vue2-datepicker/index.css'
    import Typeahead from '@/components/Typeahead'
    export default {
        name: 'general-reimbursement',
        components: {
            PaginatedTable,
            DatePicker,
            Typeahead
        },
        data: function() {
        var currentDate = new Date();
        var monthlymonth = new Date(currentDate)
        var twoDigitFirstMonth= ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
        var twoDigitFirstDate= "01";
        var createdDateTo = currentDate.getFullYear() + "-" + twoDigitFirstMonth + "-" + twoDigitFirstDate;

        var currentDate = new Date();
        var monthly = new Date(currentDate)
        var thismonth = ("0" + (monthlymonth.getMonth() + 1)).slice(-2);
        var twoDigitFirstDates= "31";
        var thismonthday = currentDate.getFullYear() + "-" + thismonth + "-" + twoDigitFirstDates;
            return {
                dataKey: 'reimbursement',
                apiUrl: {
                    profile : window.AppConfig.apiUrl + 'profile',
                    reimbursement : window.AppConfig.apiUrl + 'reimbursement',
                    reimbursementType: window.AppConfig.apiUrl + 'reimbursement-type',
                    exportPayment: window.AppConfig.apiUrl + 'export-payment-reimbursement'
                },
                thismonthday: thismonthday,
                createdDateTo: createdDateTo,
                reimbursementList: [
                    {
                        value: null,
                        text: 'Type'
                    }
                ],
                statusList: [
                    {
                        value: null,
                        text: 'Status'
                    },
                    {
                        value: 'Requested',
                        text: 'Requested'
                    },
                    {
                        value: 'Approved',
                        text: 'Approved'
                    },
                    {
                        value: 'Rejected',
                        text: 'Rejected'
                    },
                    {
                        value: 'Paid',
                        text: 'Paid'
                    }
                ],
                parentList: [
                  {
                    value: null,
                    text: 'PIC Name'
                  }
                ],
                columns: [
                    {
                        key: 'requestedBy',
                        label: 'Employee',
                        sortable: true
                    },
                    {
                        key: 'createdAt',
                        label: 'Date',
                        sortable: true
                    },
                    {
                        key: 'amount',
                        label: 'Amount',
                        sortable: true
                    },
                    {
                        key: 'reimburseType',
                        label: 'Type',
                        sortable: true
                    },
                    {
                        key: 'note',
                        label: 'Note'
                    },
                    {
                        key: 'statusPayment',
                        label: 'Status'
                    },
                    {
                        key: 'actions',
                        label: ''
                    }
                ],
                tableFilter: {
                    reimbursementType: null,
                    search_employee: this.$route.query.search_employee,
                    no_request: this.$route.query.no_request,
                    status: this.$route.query.status,
                    statusreimbursement: null,
                    requested_by: this.$route.query.requested_by,
                    approved_by: this.$route.query.approved_by,
                    rejected_by: this.$route.query.rejected_by,
                    parent_uuid: this.$route.query.parent_uuid,
                    parent: null,
                    reimbursement_type_uuid: this.$route.query.reimbursement_type_uuid,
                    date: null,
                    start_date: this.$route.query.start_date,
                    end_date: this.$route.query.end_date,
                    userRequestedBy: {
                        value: null
                    },
                    userApprovedBy: {
                        value: null
                    },
                    userRejectedBy: {
                        value: null
                    }
                }
            }
        },
        watch: {
            // 'fakeTableFilter.requestedBy' (value) {
            //     this.tableFilter.requestedBy = value ? 1 : null
            //     this.doFilter()
            // },
            // 'tableFilter.date' (value) {
            //     if (value.length >= 1 && value[0] === null && value[1] === null) {
            //         this.tableFilter.date = null
            //         this.doFilter()
            //     } else {
            //         this.doFilter()
            //     }
            // },
            // 'tableFilter.no_request' () {
            //     this.doFilter()
            // },
            // 'tableFilter.reimbursementType' () {
            //     this.doFilter()
            // },
            // 'tableFilter.statusreimbursement' () {
            //     this.doFilter()
            // },
            // 'tableFilter.parent' () {
            //     this.doFilter()
            // }
        },
        mounted () {
            this.getreimbursementType()
            this.getPICName()
        },
        methods: {
            doFilter () {
                this.tableFilter.reimbursement_type_uuid = this.tableFilter.reimbursementType
                this.tableFilter.status = this.tableFilter.statusreimbursement
                this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
                this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            clearFilter () {
                this.tableFilter.reimbursementType = null
                this.tableFilter.statusreimbursement = null
                this.tableFilter.parent = null
                this.tableFilter.search_employee = null
                this.tableFilter.search_approved_by = null
                this.tableFilter.search_rejected_by = null
                this.tableFilter.date = null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            getreimbursementType () {
                this.$http.get(this.apiUrl.reimbursementType + '?limit=100').then(resp => {
                    resp.data._embedded.reimbursementType.forEach(data => {
                        this.reimbursementList.push({
                            value: data.uuid,
                            text: data.name
                        })
                    })
                })
            },
            getPICName () {
              this.$http.get(window.AppConfig.apiUrl + 'user-access').then(response => {
                response.data._embedded.user_access.forEach(data => {
                  let employeeFirstName = data.userProfile.firstName !== null ? data.userProfile.firstName : ''
                  let employeeLastName = data.userProfile.lastName !== null ? data.userProfile.lastName : ''
                  let names = employeeFirstName + '\xa0' + employeeLastName
                  this.fullName = names
                  this.parentList.push({
                    value: data.userProfile.uuid,
                    text: this.fullName
                  })
                })
              })
            },
            doFilter () {
                this.tableFilter.parent_uuid = this.tableFilter.parent
                this.tableFilter.no_request = this.tableFilter.no_request
                this.tableFilter.reimbursement_type_uuid = this.tableFilter.reimbursementType
                this.tableFilter.status = this.tableFilter.statusreimbursement
                this.tableFilter.approved_by = this.tableFilter.userApprovedBy.value
                this.tableFilter.requested_by = this.tableFilter.userRequestedBy.value
                this.tableFilter.rejected_by = this.tableFilter.userRejectedBy.value
                this.tableFilter.start_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') : null
                this.tableFilter.end_date = this.tableFilter.date !== null ? this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD') : null
                this.$refs.dataTable.doFilter(this.tableFilter)
            },
            doExportToExcel () {
              let url = this.apiUrl.exportPayment + '?token=' + this.$store.getters['account/tokens'].access_token
              if (this.tableFilter.requested_by !== undefined && this.tableFilter.requested_by !== null) {
                url += '&requested_by=' + this.tableFilter.requested_by
              }
              if (this.tableFilter.reimbursement_type_uuid !== undefined && this.tableFilter.reimbursement_type_uuid !== null) {
                url += '&reimbursement_type_uuid=' + this.tableFilter.reimbursement_type_uuid
              }
              if (this.tableFilter.search_employee !== undefined && this.tableFilter.search_employee !== null) {
                url += '&search_employee=' + this.tableFilter.search_employee
              }
              if (this.tableFilter.parent_uuid !== undefined && this.tableFilter.parent_uuid !== null) {
                url += '&parent_uuid=' + this.tableFilter.parent_uuid
              }
              if (this.tableFilter.status !== undefined && this.tableFilter.status !== null) {
                url += '&status=' + this.tableFilter.status
              }
              if (this.tableFilter.no_request !== undefined && this.tableFilter.no_request !== null) {
                url += '&no_request=' + this.tableFilter.no_request
              }
              if (this.tableFilter.date !== null) {
                url += '&start_date=' + this.$moment(this.tableFilter.date[0]).format('YYYY-MM-DD') + '&end_date=' + this.$moment(this.tableFilter.date[1]).format('YYYY-MM-DD')
              }
              if (this.tableFilter.start_date === this.createdDateTo && this.tableFilter.end_date === this.thismonthday && this.tableFilter.status === 'Approved') {
                url += '&start_date=' + this.createdDateTo + '&end_date=' + this.thismonthday + '&status=Approved'
              }
              window.open(url)
            },
            getDateTime (value) {
                if (value !== null) {
                    return this.$moment(value).format('YYYY-MM-DD HH:mm')
                } else {
                    return '-'
                }
            },
            reset () {
                this.tableFilter.requestedBy = null
            }
        }
    }
</script>